import { useEffect } from 'react'
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router'

import { ApiError } from '@/api/errors'
import { Button, ErrorState } from '@/design'
import { reportError } from '@/lib/telemetry'

const notFound = new ApiError({ kind: 'api', status: 404, code: 'NOT_FOUND', message: 'Not found' })

export function NotFoundPage() {
  const navigate = useNavigate()
  return (
    <div className="mx-auto max-w-[520px] py-10">
      <ErrorState error={notFound} />
      <div className="text-center">
        <Button variant="primary" onClick={() => void navigate('/')}>
          Go home
        </Button>
      </div>
    </div>
  )
}

/** Router-level boundary: a thrown ApiError (loader/lazy) or an unexpected exception. */
export function RouteErrorPage() {
  const error = useRouteError()
  const value =
    error instanceof ApiError
      ? error
      : isRouteErrorResponse(error)
        ? new ApiError({
            kind: 'transport',
            status: error.status,
            code: error.status === 404 ? 'NOT_FOUND' : 'INTERNAL_ERROR',
            message: error.statusText,
          })
        : new Error(error instanceof Error ? error.message : 'Unexpected error')
  // One structured console line per boundary hit (docs/runbook.md) — no third-party transport.
  useEffect(() => {
    reportError(error, 'route-boundary')
  }, [error])
  return (
    <div className="mx-auto max-w-[520px] py-10">
      <ErrorState
        error={value}
        onRetry={() => {
          window.location.reload()
        }}
      />
    </div>
  )
}
